import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginSecurityPage } from '@/pages/super-admin/login-security/LoginSecurityPage';

const loginSecuritySearchSchema = z.object({
	page: z.number().optional(),
	limit: z.number().optional(),
	kind: z.string().optional(),
	scope: z.string().optional(),
	instance: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/login-security/')({
	component: LoginSecurityPage,
	validateSearch: loginSecuritySearchSchema,
});
